/* @flow */

import * as React from 'react'

import {
  ColorInput,
  ControlLabel,
  FormGroup,
  FormInput,
  RadioInput,
  SelectInput,
  TextareaInput,
} from '../../../../../infrastructure/components/Formik'
import FontSelector from '../../../../../infrastructure/components/FontSelector'
import { SettingsSeparator, SpacingSettings } from '../shared'

const WebshopAnnouncementBarSettings = ({ values }) => {
  return (
    <div>
      <FormGroup>
        <ControlLabel required>Announcement</ControlLabel>

        <TextareaInput name="data.announcement" rows="5" />
      </FormGroup>
      <FormGroup>
        <ControlLabel>Style</ControlLabel>
        <RadioInput
          label="Static text"
          name="data.style"
          id="style-static"
          value="static"
        />
        <RadioInput
          label="Ticker-style scrolling text"
          name="data.style"
          id="style-ticker"
          value="ticker"
        />
      </FormGroup>
      <FormGroup>
        <ControlLabel>Background color</ControlLabel>
        <ColorInput name="data.background_color" />
      </FormGroup>
      <FormGroup>
        <ControlLabel>Text color</ControlLabel>
        <ColorInput name="data.font_color" />
      </FormGroup>
      <FormGroup>
        <ControlLabel>Font</ControlLabel>
        <SelectInput
          name="data.font"
          selectComponent={FontSelector}
          simpleValue
        />
      </FormGroup>
      <FormGroup>
        <ControlLabel>Font size (px)</ControlLabel>
        <FormInput name="data.font_size" />
      </FormGroup>
      <FormGroup>
        <ControlLabel>Height (px)</ControlLabel>
        <FormInput name="data.height" />
      </FormGroup>
      {values.data.style === 'ticker' && (
        <FormGroup>
          <ControlLabel>Ticker speed (in seconds)</ControlLabel>
          <FormInput name="data.ticker_speed" />
        </FormGroup>
      )}

      <SettingsSeparator />

      <SpacingSettings enabledSpacingKeys={enabledSpacingKeys} />
    </div>
  )
}

export default WebshopAnnouncementBarSettings

const enabledSpacingKeys = ['marginTop', 'marginBottom']
